import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_SHOPIFY {
  SOURCE_DETAILS,
  CONNECT_APP,
  COMPLETED,
}

export const CREATE_DATA_SOURCE_SHOPIFY_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_SHOPIFY.SOURCE_DETAILS,
    title: 'data_source_edit.shopify.steps.source_details',
  },
  {
    id: CREATE_DATA_SOURCE_SHOPIFY.CONNECT_APP,
    title: 'data_source_edit.shopify.steps.connect_app',
  },
  {
    id: CREATE_DATA_SOURCE_SHOPIFY.COMPLETED,
    title: 'data_source_edit.shopify.steps.completed',
  },
];
